import { Children, type HTMLAttributes } from 'react';
import { clsx } from '../clsx';
import styles from './FormRow.module.css';

export interface FormRowProps extends HTMLAttributes<HTMLDivElement> {
  /** Number of equal columns; defaults to the number of children (dialog forms use 2 or 3). */
  columns?: 1 | 2 | 3 | 4 | undefined;
  /** Explicit grid tracks when the columns are not equal, e.g. "minmax(0,1fr) 120px". */
  tracks?: string | undefined;
}

/** One row of a form: equal columns with the 14 px gap of the dialogs; one column below 768 px. */
export function FormRow({ columns, tracks, className, style, children, ...rest }: FormRowProps) {
  const count = columns ?? Math.max(1, Children.count(children));
  return (
    <div
      className={clsx(styles.row, className)}
      style={{ gridTemplateColumns: tracks ?? `repeat(${count}, minmax(0, 1fr))`, ...style }}
      {...rest}
    >
      {children}
    </div>
  );
}
